import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6a530909&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a530909')) {
      api.createRecord('6a530909', component.options)
    } else {
      api.reload('6a530909', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6a530909&", function () {
      api.rerender('6a530909', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/PushNotifications/Components/Index.vue"
export default component.exports